<div class="inventory-list-container">
  <!-- Stock Report Export Dialog -->
  <p-dialog
    header="Download Stock Report"
    [(visible)]="showStockReportDialog"
    [modal]="true"
    [style]="{ width: '550px' }"
    [closable]="true"
  >
    <div class="stock-report-dialog-content">
      <!-- Report Mode Toggle -->
      <div class="form-field">
        <label class="font-semibold text-sm mb-2">Report Type</label>
        <div class="flex gap-4">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" name="stockReportMode" value="monthly" [(ngModel)]="stockReportMode" class="accent-blue-500" />
            <span class="text-sm">Monthly</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" name="stockReportMode" value="date_range" [(ngModel)]="stockReportMode" class="accent-blue-500" />
            <span class="text-sm">Date Range</span>
          </label>
        </div>
      </div>

      <div class="form-field">
        <label class="font-semibold text-sm mb-2">Subsidiary <span class="text-red-500">*</span></label>
        <p-multiselect
          [(ngModel)]="selectedSubsidiaries"
          [options]="subsidiaryOptions"
          optionLabel="label"
          [filter]="true"
          display="chip"
          [maxSelectedLabels]="2"
          placeholder="Select Subsidiaries"
          [style]="{ width: '100%' }"
          (onChange)="onSubsidiarySelectionChange($event)"
        >
          <ng-template let-option pTemplate="item">
            <div [class.select-all-option]="option.isSelectAll">
              {{ option.label }}
            </div>
          </ng-template>
        </p-multiselect>
      </div>

      <!-- Monthly mode: Month picker -->
      @if (stockReportMode === 'monthly') {
        <div class="form-field">
          <label class="font-semibold text-sm mb-2">Month <span class="text-red-500">*</span></label>
          <p-datepicker
            [(ngModel)]="selectedMonth"
            view="month"
            dateFormat="MM yy"
            [showIcon]="true"
            [style]="{ width: '100%' }"
            size="small"
            placeholder="Select Month"
          ></p-datepicker>
        </div>
      }

      <!-- Date Range mode: Start and End date pickers -->
      @if (stockReportMode === 'date_range') {
        <div class="form-field">
          <label class="font-semibold text-sm mb-2">Start Date <span class="text-red-500">*</span></label>
          <p-datepicker
            [(ngModel)]="stockReportStartDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [style]="{ width: '100%' }"
            size="small"
            placeholder="Select Start Date"
            [appendTo]="'body'"
            fluid
          ></p-datepicker>
        </div>
        <div class="form-field">
          <label class="font-semibold text-sm mb-2">End Date <span class="text-red-500">*</span></label>
          <p-datepicker
            [(ngModel)]="stockReportEndDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [style]="{ width: '100%' }"
            size="small"
            placeholder="Select End Date"
            [minDate]="stockReportStartDate"
            [appendTo]="'body'"
            fluid
          ></p-datepicker>
        </div>
      }
    </div>
    <ng-template pTemplate="footer">
      <div class="flex items-center gap-3 justify-between">
        <!-- Independent of the Monthly/Date Range modes: current stock needs no dates -->
        <p-button
          label="Current Stock"
          icon="pi pi-box"
          [outlined]="true"
          [loading]="isExportingCurrentStock"
          [disabled]="!selectedSubsidiaries.length || isExportingReport"
          (onClick)="downloadCurrentStock()"
          severity="primary"
          size="small"
          pTooltip="Download inventory as it stands right now"
          tooltipPosition="top"
        ></p-button>
        <div class="flex items-center gap-3">
        <p-button
          label="Cancel"
          severity="secondary"
          [outlined]="true"
          (onClick)="showStockReportDialog = false"
          size="small"
        ></p-button>
        <p-button
          label="Download"
          icon="pi pi-download"
          [loading]="isExportingReport"
          [disabled]="isStockReportDownloadDisabled || isExportingCurrentStock"
          (onClick)="downloadStockReport()"
          severity="primary"
          size="small"
        ></p-button>
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Location Selector -->
  <div class="location-selector-bar">
    <div class="location-selector">
      <label for="locationSelect" class="location-label">Location:</label>
      <p-select
        id="locationSelect"
        [options]="locationOptions"
        [(ngModel)]="selectedLocationId"
        (onChange)="onLocationChange($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Location"
        [style]="{ 'min-width': '300px' }"
        [showClear]="false"
      >
      </p-select>
    </div>
  </div>

  <!-- Summary Bar -->
  <div class="summary-bar">
    <div class="summary-left">
      <div class="export-actions">
        <button
          type="button"
          pButton
          icon="pi pi-file"
          class="p-button-text p-button-sm"
          (click)="exportCsv()"
          pTooltip="Export CSV"
          tooltipPosition="top"
        ></button>
        <button
          type="button"
          pButton
          icon="pi pi-file-excel"
          class="p-button-text p-button-sm"
          (click)="exportXlsx()"
          pTooltip="Export Excel"
          tooltipPosition="top"
        ></button>
        <button
          type="button"
          pButton
          icon="pi pi-file-pdf"
          class="p-button-text p-button-sm"
          (click)="exportPdf()"
          pTooltip="Export PDF"
          tooltipPosition="top"
        ></button>
        <button
          type="button"
          pButton
          icon="pi pi-print"
          class="p-button-text p-button-sm"
          (click)="exportPdf()"
          pTooltip="Print"
          tooltipPosition="top"
        ></button>
      </div>
      <div class="filter-checkboxes">
        <p-checkbox
          [(ngModel)]="showLowStock"
          (onChange)="onShowLowStockChange($event)"
          inputId="showLowStock"
          label="Show Low on Stock"
        >
        </p-checkbox>
        <p-checkbox
          [(ngModel)]="showNearExpiry"
          (onChange)="onShowNearExpiryChange($event)"
          inputId="showNearExpiry"
          label="Show Near Expiry"
        >
        </p-checkbox>
      </div>
    </div>
    <div class="summary-right">
      <div class="summary-totals">
        <span class="total-label"
          >Total MRP: {{ formatCurrency(totalMRP) }}</span
        >
        <span class="total-separator">|</span>
        <span class="total-label"
          >Total Rate: {{ formatCurrency(totalRate) }}</span
        >
      </div>
      <div class="total-items">
        <span>Total Items: {{ totalCount }}</span>
      </div>
    </div>
  </div>

  <!-- Dynamic Listing Component -->
  <lib-dynamic-listing
    [module]="'inventory'"
    [filters]="filterConfigs"
    [columns]="columnConfigs"
    [data]="tableData"
    [actions]="actionConfigs"
    [headerActions]="headerActionConfigs"
    [isLoading]="isLoading"
    [pageIndex]="pageIndex"
    [rowsPerPage]="rowsPerPage"
    [totalCount]="totalCount"
    [totalPages]="totalPages"
    [exportFilename]="exportFilename"
    [showExportButtons]="false"
    (filterEvent)="onFilterEvent($event)"
    (actionClicked)="onActionClicked($event)"
    (pageChanged)="onPageChanged($event)"
    (columnsSelected)="onColumnsSelected($event)"
  >
  </lib-dynamic-listing>

  <app-bulk-upload
    [(visible)]="showBulkUploadDialog"
    [module]="'inventory'"
    [mode]="'create'"
    (uploadSuccess)="onBulkUploadSuccess($event)">
  </app-bulk-upload>
</div>
